import { render, staticRenderFns } from "./PersonInfoManage.vue?vue&type=template&id=36eee0b3&scoped=true&"
import script from "./PersonInfoManage.vue?vue&type=script&lang=js&"
export * from "./PersonInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfoManage.vue?vue&type=style&index=0&id=36eee0b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eee0b3",
  null
  
)

export default component.exports